import { render } from "./SnippetContactDetails.vue?vue&type=template&id=0ddb35f2&scoped=true"
import script from "./SnippetContactDetails.vue?vue&type=script&lang=js"
export * from "./SnippetContactDetails.vue?vue&type=script&lang=js"

import "./SnippetContactDetails.vue?vue&type=style&index=0&id=0ddb35f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddb35f2"]])

export default __exports__